import { render, staticRenderFns } from "./IntroModal.vue?vue&type=template&id=406f3a38&scoped=true&"
import script from "./IntroModal.vue?vue&type=script&lang=js&"
export * from "./IntroModal.vue?vue&type=script&lang=js&"
import style0 from "./IntroModal.vue?vue&type=style&index=0&id=406f3a38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f3a38",
  null
  
)

export default component.exports